import { useState, useEffect } from 'react';
import { getData } from '../../../webService/webservice.js';
import { Typography } from '@mui/material';
const BookingHeader = ({ onApplyFilters }) => {
    const [customers, setCustomers] = useState([]);
    const [stores, setStores] = useState([]);
    const role = localStorage.getItem("role");
    const userId = localStorage.getItem("userId");
    const adminStoreIds = JSON.parse(localStorage.getItem("storeIds") || "[]");
    const initialStoreId = adminStoreIds[0] || "";
    const [clusterStoreIds, setClusterStoreIds] = useState([]);
    const [selectedStoreId, setSelectedStoreId] = useState(
        initialStoreId
    );
    const [currentPage, setCurrentPage] = useState(1);

    const [filters, setFilters] = useState({
        status: "",
        customerId: "",
        storeId: "",
        sortBy: "",
    });
    const handleChange = (e) => {
        const { id, value } = e.target;
        setFilters((prev) => ({ ...prev, [id]: value }));
    };

    const handleClear = () => {
        const empty = {
            status: "",
            customerId: "",
            storeId: "",
            storeName: "",
            sortBy: "",
        };
        setFilters(empty);

        // Remove any persisted filters
        localStorage.removeItem("bookingFilters");

        if (typeof onApplyFilters === "function") {
            onApplyFilters({});
        }
    };
    const handleApply = () => {
        localStorage.setItem("bookingFilters", JSON.stringify(filters));
        if (typeof onApplyFilters === "function") {
            onApplyFilters(filters);
        }
    };

    useEffect(() => {
        const fetchStores = async () => {
            try {
                const token = localStorage.getItem("Token");
                const data = await getData('stores/stores', {}, token);
                console.log('API Full Response:', data);
                const results = data?.data?.results || [];
                setStores(results);

            } catch (error) {
                console.error("Failed to load stores", error);
            }
        };
        fetchStores();
    }, []);

    useEffect(() => {
        const storedStoreId = localStorage.getItem("storeId");
        if (storedStoreId && stores.length > 0) {
            const matchedStore = stores.find((store) => store._id === storedStoreId);
            if (matchedStore) {
                setFilters((prev) => ({
                    ...prev,
                    storeId: matchedStore._id,
                    storeName: matchedStore.storeName,
                }));
            }
        }
    }, [stores]);

    useEffect(() => {
        const fetchCustomers = async () => {
            try {
                const token = localStorage.getItem("Token");
                const params = {
                    storeId: initialStoreId
                }
                const data = await getData('customers/customers', params, token);  // Adjust endpoint as needed
                console.log("API Full Response: ", data);
                const results = data?.data?.[0]?.paginatedResults || [];
                setCustomers(results);
            } catch (error) {
                console.error("Failed to load customers", error);
            }
        };

        fetchCustomers();
    }, []);

    useEffect(() => {
        const handleStoreChange = () => {
            const storeId = selectedStoreId;
            setSelectedStoreId(storeId);
            setCurrentPage(1);
        };

        window.addEventListener("storeChanged", handleStoreChange);
        return () => window.removeEventListener("storeChanged", handleStoreChange);
    }, []);

    useEffect(() => {
        if (role === "ClusterManager") {
            const assignedStores = stores
                .filter(s => s.clusterManager?._id === userId)
                .map(s => s._id);

            setClusterStoreIds(assignedStores);
        }
    }, [stores, role]);

    const handleStoreChange = (e) => {
        const storeId = e.target.value;
        setSelectedStoreId(storeId);
        setSelectedStoreId(storeId)

        // Dispatch event to notify CategoryPage
        window.dispatchEvent(new Event("storeChanged"));
    };

    return (
        <>
            <div className="booking-filter-container">
                <div className="booking-filter-header">
                    <div className="filter-title-section">
                        <Typography variant="h6">Filters</Typography>
                        <p className="filter-subtitle">Refine your appointment search</p>
                    </div>
                </div>

                <div className="booking-filters-grid">
                    {/* Status */}
                    <div className="filter-group">
                        <label className="filter-label">Status</label>
                        <select
                            id="status"
                            className="filter-select"
                            value={filters.status || ""}
                            onChange={handleChange}
                        >
                            <option value="">All Status</option>
                            <option value="Completed">Completed</option>
                            <option value="In Progress">In Progress</option>
                            <option value="Pending">Pending</option>
                            <option value="Cancelled">Cancelled</option>
                            <option value="Scheduled">Scheduled</option>
                            <option value="Rejected">Rejected</option>
                            <option value="Approved">Approved</option>
                        </select>
                    </div>

                    {/* Customer */}
                    <div className="filter-group">
                        <label className="filter-label">Customer</label>
                        <select
                            id="customerId"
                            className="filter-select"
                            value={filters.customerId || ""}
                            onChange={handleChange}
                        >
                            <option value="">All Customers</option>
                            {customers?.map((cust) => (
                                <option key={cust._id} value={cust._id}>
                                    {cust.name}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>

                <div className="filter-actions">
                    <button
                        className="cancel-Product-button"
                        onClick={handleClear}
                        type='button'
                    >
                        Clear All
                    </button>
                    <button
                        className="add-Product-button"
                        type='button'
                        onClick={handleApply}
                    >
                        Apply Filters
                    </button>
                </div>
            </div>
        </>
    );
};

export default BookingHeader;